import React from "react";
import PluginPlaceholder from "../../_editor/components/canvas/plugin_placeholder/PluginPlaceholder";
import i18n from "i18next";
import { contentT } from "../../common/content_language";
import "./_multipleAnswer.scss";
import {
  letterFromNumber,
  setRgbaAlpha,
  isShowNumbersCondition,
  getButtonText,
} from "../../common/common_tools";
import AnswerButton from "../FreeResponse/visor/SubmitAnswerButton";
/* eslint-disable react/prop-types */

export function MultipleAnswer(base) {
  return {
    getConfig: function () {
      return {
        name: "MultipleAnswer",
        displayName: IdealStudio.i18n.t("MultipleAnswer.PluginName"),
        category: "evaluation",
        icon: "check_box",
        initialWidth: "100%",
        initialHeight: "100%",
        initialWidthSlide: "100%",
        initialHeightSlide: "100%",
        flavor: "react",
        isComplex: true,
        defaultCorrectAnswer: [],
      };
    },
    getToolbar: function (state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            __score: {
              __name: i18n.t("configuration"),
              icon: "build",
              buttons: {
                nBoxes: {
                  __name: i18n.t("MultipleAnswer.Number"),
                  type: "number",
                  value: state.nBoxes,
                  max: 6,
                  min: 1,
                },
                showFeedback: {
                  __name: i18n.t("MultipleAnswer.ShowFeedback"),
                  type: "checkbox",
                  checked: state.showFeedback,
                },
                allowPartialScore: {
                  __name: i18n.t("MultipleAnswer.AllowPartialScore"),
                  type: "checkbox",
                  checked: state.allowPartialScore,
                },
                shuffle: {
                  __name: i18n.t("MultipleChoice.Shuffle"),
                  type: "checkbox",
                  checked: state.shuffle,
                },
                buttons: {
                  __name: i18n.t("MultipleChoice.WhichButtons"),
                  type: "radio",
                  value: state.buttons,
                  options: ["tryAgain", "seeAnswer"],
                  labels: [i18n.t("MultipleChoice.tryAgain"), i18n.t("MultipleChoice.seeAnswer")],
                },
                checkAnswerText: {
                  __name: i18n.t("MultipleAnswer.CheckAnswerText") || "Check Answer Button Text",
                  type: "text",
                  value: getButtonText(state.checkAnswerText, "MultipleChoice.checkAnswer"),
                },
                tryAgainText: {
                  __name: i18n.t("MultipleAnswer.TryAgainText") || "Try Again Button Text",
                  type: "text",
                  value: getButtonText(state.tryAgainText, "MultipleChoice.tryAgain"),
                  hide: state.buttons !== "tryAgain",
                },
                seeAnswerText: {
                  __name: i18n.t("MultipleAnswer.SeeAnswerText") || "See Answer Button Text",
                  type: "text",
                  value: getButtonText(state.seeAnswerText, "MultipleChoice.seeAnswer"),
                  hide: state.buttons !== "seeAnswer",
                },
                letters: {
                  __name: i18n.t("MultipleAnswer.ShowLettersInsteadOfNumbers"),
                  type: "radio",
                  value: isShowNumbersCondition(state.letters) ? "numbers" : "letters",
                  options: ["letters", "numbers"],
                  labels: [
                    i18n.t("MultipleAnswer.ShowLetters"),
                    i18n.t("MultipleAnswer.ShowNumbers"),
                  ],
                },
                quizColor: {
                  __name: IdealStudio.i18n.t("MultipleChoice.Color"),
                  type: "color",
                  value: state.quizColor || "rgba(234, 183, 0, 1)",
                },
              },
            },
            __buttonStyle: {
              __name: IdealStudio.i18n.t("MultipleAnswer.ButtonStyle") || "Button Style",
              icon: "palette",
              buttons: {
                buttonBackgroundColor: {
                  __name:
                    IdealStudio.i18n.t("MultipleAnswer.ButtonBackground") ||
                    "Button Background Color",
                  type: "color",
                  value: state.buttonBackgroundColor || "#EAB700",
                },
                buttonTextColor: {
                  __name:
                    IdealStudio.i18n.t("MultipleAnswer.ButtonTextColor") || "Button Text Color",
                  type: "color",
                  value: state.buttonTextColor || "#ffffff",
                },
                buttonBorderColor: {
                  __name:
                    IdealStudio.i18n.t("MultipleAnswer.ButtonBorderColor") || "Button Border Color",
                  type: "color",
                  value: state.buttonBorderColor || "#EAB700",
                },
                buttonHoverBackgroundColor: {
                  __name:
                    IdealStudio.i18n.t("MultipleAnswer.ButtonHoverBackground") ||
                    "Button Hover Background Color",
                  type: "color",
                  value: state.buttonHoverBackgroundColor || "#e67700",
                },
                advancedSettings: {
                  __name: IdealStudio.i18n.t("AdvancedSettings") || "Advanced Settings",
                  type: "checkbox",
                  checked: state.advancedSettings || false,
                },
                buttonBorderWidth: {
                  __name:
                    IdealStudio.i18n.t("MultipleAnswer.ButtonBorderWidth") || "Button Border Width",
                  type: "range",
                  value: state.buttonBorderWidth || 1,
                  min: 0,
                  max: 5,
                  step: 1,
                  hide: !state.advancedSettings,
                },
                buttonBorderRadius: {
                  __name:
                    IdealStudio.i18n.t("MultipleAnswer.ButtonBorderRadius") ||
                    "Button Border Radius",
                  type: "range",
                  value: state.buttonBorderRadius || 4,
                  min: 0,
                  max: 25,
                  step: 1,
                  hide: !state.advancedSettings,
                },
                buttonPadding: {
                  __name: IdealStudio.i18n.t("MultipleAnswer.ButtonPadding") || "Button Padding",
                  type: "range",
                  value: state.buttonPadding || 8,
                  min: 4,
                  max: 20,
                  step: 1,
                  hide: !state.advancedSettings,
                },
                buttonFontSize: {
                  __name: IdealStudio.i18n.t("MultipleAnswer.ButtonFontSize") || "Button Font Size",
                  type: "range",
                  value: state.buttonFontSize || 14,
                  min: 10,
                  max: 24,
                  step: 1,
                  hide: !state.advancedSettings,
                },
                buttonFontWeight: {
                  __name:
                    IdealStudio.i18n.t("MultipleAnswer.ButtonFontWeight") || "Button Font Weight",
                  type: "select",
                  value: state.buttonFontWeight || "normal",
                  options: [
                    "normal",
                    "bold",
                    "100",
                    "200",
                    "300",
                    "400",
                    "500",
                    "600",
                    "700",
                    "800",
                    "900",
                  ],
                  labels: [
                    i18n.t("styles.font_weight.normal") || "normal",
                    i18n.t("styles.font_weight.bold") || "bold",
                    i18n.t("styles.font_weight.100") || "100",
                    i18n.t("styles.font_weight.200") || "200",
                    i18n.t("styles.font_weight.300") || "300",
                    i18n.t("styles.font_weight.400") || "400",
                    i18n.t("styles.font_weight.500") || "500",
                    i18n.t("styles.font_weight.600") || "600",
                    i18n.t("styles.font_weight.700") || "700",
                    i18n.t("styles.font_weight.800") || "800",
                    i18n.t("styles.font_weight.900") || "900",
                  ],
                  hide: !state.advancedSettings,
                },
              },
            },
            style: {
              __name: IdealStudio.i18n.t("HotspotImages.box_style"),
              icon: "palette",
              buttons: {
                padding: {
                  __name: IdealStudio.i18n.t("HotspotImages.padding"),
                  type: "number",
                  value: 10,
                  min: 0,
                  max: 100,
                },
                backgroundColor: {
                  __name: IdealStudio.i18n.t("HotspotImages.background_color"),
                  type: "color",
                  value: "#ffffff",
                },
                borderWidth: {
                  __name: IdealStudio.i18n.t("HotspotImages.border_size"),
                  type: "number",
                  value: 1,
                  min: 0,
                  max: 10,
                },
                borderStyle: {
                  __name: IdealStudio.i18n.t("HotspotImages.border_style"),
                  type: "select",
                  value: "solid",
                  options: [
                    "none",
                    "hidden",
                    "dotted",
                    "dashed",
                    "solid",
                    "double",
                    "groove",
                    "ridge",
                    "inset",
                    "outset",
                    "initial",
                    "inherit",
                  ],
                  labels: [
                    i18n.t("styles.border_style_options.none") || "none",
                    i18n.t("styles.border_style_options.hidden") || "hidden",
                    i18n.t("styles.border_style_options.dotted") || "dotted",
                    i18n.t("styles.border_style_options.dashed") || "dashed",
                    i18n.t("styles.border_style_options.solid") || "solid",
                    i18n.t("styles.border_style_options.double") || "double",
                    i18n.t("styles.border_style_options.groove") || "groove",
                    i18n.t("styles.border_style_options.ridge") || "ridge",
                    i18n.t("styles.border_style_options.inset") || "inset",
                    i18n.t("styles.border_style_options.outset") || "outset",
                    i18n.t("styles.border_style_options.initial") || "initial",
                    i18n.t("styles.border_style_options.inherit") || "inherit",
                  ],
                },
                borderColor: {
                  __name: IdealStudio.i18n.t("HotspotImages.border_color"),
                  type: "color",
                  value: "#dbdbdb",
                },
                borderRadius: {
                  __name: IdealStudio.i18n.t("HotspotImages.radius"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 50,
                },
                opacity: {
                  __name: IdealStudio.i18n.t("HotspotImages.opacity"),
                  type: "range",
                  value: 1,
                  min: 0,
                  max: 1,
                  step: 0.01,
                },
              },
            },
          },
        },
      };
    },
    getInitialState: function () {
      return {
        nBoxes: 3,
        showFeedback: true,
        shuffle: false,
        buttons: "tryAgain",
        letters: "letters",
        allowPartialScore: false,
        quizColor: "rgba(237, 233, 254, 1)",
        checkAnswerText: null,
        tryAgainText: null,
        seeAnswerText: null,
        buttonBackgroundColor: "#ede9fe",
        buttonTextColor: "#111827",
        buttonBorderColor: "#ede9fe",
        buttonBorderWidth: 1,
        buttonBorderRadius: 4,
        buttonPadding: 8,
        buttonFontSize: 14,
        buttonFontWeight: "normal",
        buttonHoverBackgroundColor: "#ede9fe",
        advancedSettings: false,
      };
    },
    getRenderTemplate: function (state, props = {}) {
      let answers = [];

      function removeLastChar(s) {
        if (!s || s.length === 0) {
          return s;
        }
        return s.substring(0, s.length - 1);
      }
      let quizColor = state.buttonBackgroundColor || "rgba(234, 183, 0, 1)";
      let correctAnswers = "";
      for (let i = 0; i < state.nBoxes; i++) {
        let checked =
          props.exercises.correctAnswer &&
          props.exercises.correctAnswer instanceof Array &&
          props.exercises.correctAnswer.indexOf(i) > -1;
        answers.push(
          <div key={i + 1} className={"row answerRow"} data-answer-row={i}>
            {props.onMoveAnswer ? (
              <div className="assessment-reorder" contentEditable={false}>
                <button
                  type="button"
                  className="assessment-reorder-btn"
                  aria-label={i18n.t("messages.move_up") || "Move up"}
                  title={i18n.t("messages.move_up") || "Move up"}
                  disabled={i === 0}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.onMoveAnswer(i, -1);
                  }}
                >
                  ▲
                </button>
                <button
                  type="button"
                  className="assessment-reorder-btn"
                  aria-label={i18n.t("messages.move_down") || "Move down"}
                  title={i18n.t("messages.move_down") || "Move down"}
                  disabled={i === state.nBoxes - 1}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.onMoveAnswer(i, 1);
                  }}
                >
                  ▼
                </button>
              </div>
            ) : null}
            <div className={"col-xs-2 answerPlaceholder"}>
              <div
                className={"answer_letter"}
                style={{
                  backgroundColor: quizColor,
                  color: state.buttonTextColor,
                  borderColor: state.buttonBorderColor,
                  borderStyle: "solid",
                  borderWidth: `${state.buttonBorderWidth ?? 1}px`,
                  borderRadius: `${state.buttonBorderRadius ?? 4}px`,
                  fontSize: `${state.buttonFontSize ?? 14}px`,
                  fontWeight: state.buttonFontWeight || "normal",
                  padding: `0 ${state.buttonPadding ?? 8}px`,
                  width: "auto",
                  minWidth: "1.75em",
                }}
              >
                {isShowNumbersCondition(state.letters) ? i + 1 : letterFromNumber(i)}
              </div>
              <input
                type="checkbox"
                className="checkQuiz"
                name={props.id}
                value={i}
                checked={checked}
                onClick={(e) => {
                  let newCorrectAnswer = props.exercises.correctAnswer.filter((c) => {
                    return c < answers.length;
                  });
                  let index = newCorrectAnswer.indexOf(i);
                  if (index === -1) {
                    newCorrectAnswer.push(i);
                  } else {
                    newCorrectAnswer.splice(index, 1);
                  }

                  props.setCorrectAnswer(newCorrectAnswer);
                }}
              />
            </div>
            <div className={"col-xs-10"}>
              <PluginPlaceholder
                {...props}
                key={i}
                pluginContainerName={i18n.t("MultipleAnswer.Answer") + " " + (i + 1)}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: { __i18nKey: "MultipleAnswer.Answer", __suffix: " " + (1 + i) },
                  },
                ]}
                pluginContainer={"Answer" + i}
              />
            </div>
            {props.onRemoveAnswer ? (
              <button
                type="button"
                className="assessment-remove-answer"
                aria-label={i18n.t("messages.remove_answer")}
                title={i18n.t("messages.remove_answer")}
                onClick={(e) => {
                  e.stopPropagation();
                  props.onRemoveAnswer(i);
                }}
              >
                ×
              </button>
            ) : null}
          </div>
        );
        if (checked) {
          correctAnswers +=
            (isShowNumbersCondition(state.letters) ? i + 1 : letterFromNumber(i)) + ", ";
        }
      }
      if (!props.exercises.correctAnswer || props.exercises.correctAnswer.length === 0) {
        correctAnswers += contentT("MultipleAnswer.None") + ".";
      } else {
        correctAnswers = removeLastChar(removeLastChar(correctAnswers)) + ".";
      }
      return (
        <div
          className={"exercisePlugin multipleAnswerPlugin"}
          style={{ "--q-btn-hover-bg": state.buttonHoverBackgroundColor || "#e67700" }}
        >
          {/* <h1>Multiple Answer</h1>*/}
          <div className={"row"} key={0}>
            <div className={"col-xs-12"}>
              <PluginPlaceholder
                {...props}
                key="0"
                pluginContainerName={i18n.t("MultipleAnswer.Question")}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: { __i18nKey: "MultipleAnswer.Statement" },
                  },
                ]}
                pluginContainer={"Question"}
              />
            </div>
          </div>
          <div className="q-answer-list">{answers}</div>
          {props.onAddAnswer ? (
            <button
              type="button"
              className="assessment-add-answer"
              onClick={(e) => {
                e.stopPropagation();
                props.onAddAnswer();
              }}
            >
              + {i18n.t("messages.add_answer")}
            </button>
          ) : null}
          <div
            className={"row feedbackRow"}
            key={-2}
            style={{ display: state.showFeedback ? "block" : "none" }}
          >
            <div
              className={"col-xs-12 feedback"}
              style={{
                color: /* quizColor */ "black",
                borderColor: "#318533",
                backgroundColor: setRgbaAlpha("rgba(39,208,124,0.20)", 0.15),
              }}
            >
              <PluginPlaceholder
                {...props}
                key="-2"
                pluginContainerName={i18n.t("MultipleChoice.Feedback")}
                pluginContainer={"TrueFeedback"}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: { __i18nKey: "MultipleChoice.TrueFeedbackMsg" },
                  },
                ]}
              />
            </div>
          </div>
          <div
            className={"row feedbackRow"}
            key={-3}
            style={{ display: state.showFeedback ? "block" : "none" }}
          >
            <div
              className={"col-xs-12 feedback"}
              style={{
                color: /* quizColor */ "black",
                borderColor: "#a31111",
                backgroundColor: setRgbaAlpha("rgba(213,26,26,0.20)", 0.15),
              }}
            >
              <PluginPlaceholder
                {...props}
                key="-3"
                pluginContainerName={i18n.t("MultipleChoice.Feedback")}
                pluginContainer={"FalseFeedback"}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: { __i18nKey: "MultipleChoice.FalseFeedbackMsg" },
                  },
                ]}
              />
            </div>
          </div>
          <div className="correctAnswerFeedback" style={{ color: quizColor }}>
            <span className="correctAnswerLabel">
              {" "}
              {contentT("MultipleAnswer.correctAnswerFeedback")}:
            </span>{" "}
            {correctAnswers}
          </div>
          <style
            // legacy inline checkbox styling removed; visuals now controlled via SCSS
            dangerouslySetInnerHTML={{ __html: "" }}
          />
        </div>
      );
    },
  };
}
/* eslint-enable react/prop-types */
